/**
 * Lightweight, dependency-free analytics helper.
 * Pushes to window.dataLayer and gtag when they exist; otherwise it is a no-op.
 * Used only by the FONDEA launch page — existing page events are untouched.
 */
type EventParams = Record<string, string | number | boolean | undefined>;

interface AnalyticsWindow extends Window {
  dataLayer?: unknown[];
  gtag?: (command: string, eventName: string, params?: EventParams) => void;
}

export function trackEvent(eventName: string, params: EventParams = {}): void {
  if (typeof window === "undefined") return;
  const w = window as AnalyticsWindow;
  try {
    w.dataLayer?.push({ event: eventName, ...params });
    w.gtag?.("event", eventName, params);
  } catch {
    // Analytics must never break the UI.
  }
}

/** Keeps current UTM parameters when navigating to an internal route. */
export function withUtm(path: string): string {
  if (typeof window === "undefined") return path;
  const current = new URLSearchParams(window.location.search);
  const utm = new URLSearchParams();
  current.forEach((value, key) => {
    if (key.startsWith("utm_") || key === "gclid" || key === "ref") utm.set(key, value);
  });
  const query = utm.toString();
  if (!query) return path;
  return path.includes("?") ? `${path}&${query}` : `${path}?${query}`;
}
